import { render } from "./NoDataUi.vue?vue&type=template&id=25f18d4a&ts=true"
import script from "./NoDataUi.vue?vue&type=script&lang=ts"
export * from "./NoDataUi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__